"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrushAxis = void 0;
exports.BrushAxis = Object.freeze({
    X: 'x',
    Y: 'y',
    Both: 'both',
});
//# sourceMappingURL=brush_axis.js.map